// @flow
import React from "react";
import { FormGroup, Label, Input, Col } from "reactstrap";
import { connect } from "react-redux";
import Section from "../../components/Section";
import { updateField } from "../../../redux/actions/configActions";
import PhotoRatio from "./config-form-subsections/PhotoRatio";

import * as Constants from "../../../constants/photoDimensions";
import ImageField from "../../components/ImageField";

const mapDispatchToProps = { updateField };
const mapStateToProps = state => {
  const { configReducer } = state;
  return {
    config: configReducer.config,
    files: configReducer.files
  };
};

class BoomerangSettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      gifOverlayNumber: 0
    };

    // #region event binders
    this.handleChange = this.handleChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
    this.handleValidatedFileChange = this.handleValidatedFileChange.bind(this);
    // #endregion
  }
  // #region events

  handleChange(event) {
    this.props.updateField({ [event.target.name]: event.target.value });
  }

  handleCheckboxChange(event) {
    event.persist();
    const { config } = this.props;
    this.props.updateField({
      [event.target.name]: !config[event.target.name]
    });
  }

  handleValidatedFileChange(id, image) {
    this.props.updateField({ [id]: image });
  }

  // #endregion
  render() {
    const { config, files } = this.props;

    return (
      <React.Fragment>
        <Section title="Boomerang settings">
          <PhotoRatio />
          <FormGroup row>
            <ImageField
              id="boomerangBrand"
              label="Boomerang branding"
              required
              image={files.boomerangBrandFile}
              width={
                config.photoRatio == 1
                  ? Constants.BoomerangWidth
                  : Constants.BoomerangHeight
              }
              height={
                config.photoRatio == 1
                  ? Constants.BoomerangHeight
                  : Constants.BoomerangWidth
              }
              onDeleteChange={this.handleCheckboxChange}
              onFileChange={this.handleValidatedFileChange}
            />
          </FormGroup>
          <FormGroup row>
            <ImageField
              id="boomerangStrip"
              label="Boomerang strip"
              required
              image={files.boomerangStripFile}
              width={
                config.photoRatio == 1
                  ? Constants.LandscapeStripWidth
                  : Constants.PictureHeight
              }
              height={
                config.photoRatio == 1
                  ? Constants.LandscapeStripHeight
                  : Constants.PictureWidth
              }
              onDeleteChange={this.handleCheckboxChange}
              onFileChange={this.handleValidatedFileChange}
            />
          </FormGroup>
        </Section>
      </React.Fragment>
    );
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BoomerangSettings);



// WEBPACK FOOTER //
// ./src/views/Configuration/config-form-sections/BoomerangSettings.jsx